import { render, staticRenderFns } from "./LeaveBalanceCard.vue?vue&type=template&id=fed3a1e4"
import script from "./LeaveBalanceCard.vue?vue&type=script&lang=js"
export * from "./LeaveBalanceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports